import { Injectable, inject, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { SharedService } from '../shared.service';
import { TextResource } from '../../classes/text-resource';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class TextResourceService {

  private readonly sharedService = inject(SharedService);
  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);

  private readonly testResourcesUrl: string = "/ui-pages/???/brands/{0}?lang-code={1}&res-domain={2}";

  private readonly defaultLang: string = 'en';
  private currentLang: string = this.defaultLang;
  private readonly langs: string[] = [];

  currentLangSignal = signal('en');
  private readonly textResource: TextResource

  constructor() { 
    this.textResource = new TextResource();
  }

  // getLangs(): string[] {
  //   return this.langs;
  // }

  // setLangs(langs: string[]) {
  //   this.langs = langs;
  // }  

  // getCurrentLang(): string {
  //   return this.currentLangSignal();
  // }

  setCurrentLang(currentLang: string) {
    console.log('setCurrentLang', currentLang);
    this.currentLang = currentLang;
    this.currentLangSignal.set(currentLang);
    console.log('getSignal', this.currentLangSignal());
  }

  // setDefaultLang(defaultLang: string) {
  //   this.defaultLang = defaultLang;
  //   this.setCurrentLang(defaultLang);
  // }

  // public addLangs(langs: string[]): void
  // {
  //   const newLangs = langs.filter(lang => !this.langs.includes(lang));
  //   if (newLangs.length > 0) {
  //     this.langs = [...this.langs, ...newLangs];
  //   }
  // }  

  // public onLangChange() {

  // }

  // public changeLang(lang: string) {
    
  // }

  // public useLang(lang: string) {
  //   console.log('useLang()', lang);
  //   this.setCurrentLang(lang);
  // }



  // public getBrowserLang(): string | undefined {
  //   if (typeof window === 'undefined' || !window.navigator) {
  //     return undefined;
  //   }
  //   const browserLang = this.getBrowserCultureLang();
  //   return browserLang ? browserLang.split(/[-_]/)[0] : undefined;
  // }

  // public getBrowserCultureLang(): string | undefined {
  //   if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
  //     return undefined;
  //   }
  //   return window.navigator.languages
  //       ? window.navigator.languages[0]
  //       : (window.navigator.language 
  //       // || window.navigator.language.browserLanguage || window.navigator.userLanguage
  //     );
  // }  

  // public getTestResources(region: string, brandCode: string, langCode: string, resDomain: string): Observable<any> {
  //   var url = this.sharedService.getBaseUrlByRegion(region) 
  //       + this.sharedService.formatString(this.testResourcesUrl, brandCode, langCode, resDomain);
  //   let headers = new HttpHeaders()
  //     .set("request-origin", "csr-portal");
  //   return this.http.get<any>(url, {headers: headers, responseType: 'json'})
  //   .pipe(
  //     catchError(this.sharedService.handleError)
  //   )
  // }

  // public getTextResource(region: string, brandCode: string, langCode: string, resDomain: string) {
  //   let textResources = new Map<string, string>;
  //   if (this.textResource.hasDomainResources(resDomain)) {
  //     textResources = this.textResource.findDomainResources(resDomain);
  //   } else {
  //     this.getTestResources(region, brandCode, langCode, resDomain)
  //     .subscribe({
  //       next: (response) => {
  //         // console.log('response', response);
  //         if (response) {
  //           textResources = response;
  //         }
  //       },
  //       error: (error) => {
  //         console.log('error', error);
  //       },
  //       complete: () => {
  //         return textResources;
  //       }
  //     });
  //   }

  // }

  public getTestResource(region: string, brandCode: string, langCode: string, resourceDomain: string, resourceKey: string) {
    
  }




}
